export default __webpack_public_path__ + "static/media/2.8cd5055e.jpg";